import React, { useState } from "react"
import { BarChartDisplay } from "charts"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import CloseRoundedIcon from "@mui/icons-material/CloseRounded"
import { StyledChartDrawer } from "./Home.style"

const BarChartDlg = () => {
  const [open, setOpen] = useState(false)
  const [chartContent, setChartData] = BarChartDisplay({
    data: null,
    width: 1200,
    height: 500,
  })

  const openDlg = (data) => {
    setChartData(data)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const content = (
    <StyledChartDrawer anchor="right" open={open} onClose={handleClose}>
      <div className="chart-header">
        <h3 className="title">Data Chart</h3>
        <IconButton size="small" onClick={handleClose}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </div>
      <div className="chart-content">{chartContent}</div>
      <div className="chart-actions">
        <Button onClick={handleClose}>Close</Button>
      </div>
    </StyledChartDrawer>
  )

  return [content, openDlg]
}

export default BarChartDlg
